
import React, { useState, useContext } from 'react';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import RenderIf from "../components/RenderIf"
import { StyleContext } from '../context';
import Emoji from './Emoji';
import SampleSelect from './SampleSelect';

const InputRow = ({ onNameSelect, onNameChange, onValueChange, addEntry }) => {
    const [showForm, setShowForm] = useState(false)
    const [curr, setCurr] = useState("")
    const { variant, type } = useContext(StyleContext)

    const showBasic = () => setShowForm(false)
    const showAdvanced = () => setShowForm(true)
    return (
        <tr>
            <td>
                <RenderIf condition={showForm} fallback=
                    {
                        <SampleSelect
                            curr={curr}
                            selectOther={showAdvanced}
                            hideOther={showBasic}
                            setCurr={setCurr}
                            selectSample={onNameSelect} />
                    }>
                    <InputGroup>

                        <FormControl
                            id="inlineFormInputGroup"
                            placeholder={`${type} name here`}
                            type="text"
                            onChange={(e) => {
                                onNameChange(e)
                                setCurr(e.target.value)}} />
                        <Button variant={variant} onClick={showBasic}>
                            <Emoji symbol='😎' />
                        </Button>
                    </InputGroup>

                </RenderIf>
            </td>
            <td>
                <FormControl
                    id="inlineFormInputGroup"
                    placeholder={`${type} value here`}
                    type="number"
                    min={0}
                    onChange={onValueChange} />
            </td>
            <td><Button variant={variant} onClick={addEntry}><h3>+</h3></Button></td>
        </tr>
    )
}



export default InputRow;
